 "use strict";

angular
    .module("far.profile")
    .controller(
        "ProfileMembershipController",
        function (
            $scope,
            $window,
            $log,
            $http,
            form,
            autocomplete,
            User,
            formsUtils,
            http
        ) {
			var organizations=autocomplete.refreshAutoComplete("", "Clubs", "club");
			console.log(autocomplete.refreshAutoComplete("d", "Clubs", "club"));

            var vm = {
                progress: true,
                submitted: false,
                show_error: false,
                club_required: true,
                club_checkbox: false,
                max: null,
                form: {},
                autoCompleteSelect: {
                    country: null,
                    region: null,
                    city: null,
                },
                submit: submit,
                fields: form("ProfileMembership"),
                constructor: constructor,
                counter: 1,
                getCounter: getCounter,
                club_other_items:[  {
                id: 0,
                name: 'Отдать голос представителю региональной федерации'
             },
            // {
            //     id: 1,
            //     name: 'Отдать голос президенту ФАР, во время голосования Ваш голос будет учтен в ФАиС Москвы'
            // },
            {
                id: 2,
                name: 'Принимает участие в конференции лично'
            }],
                prev_club_id: null,
                validationExpired: true,
		 organizations:organizations,

		};

	            vm.fields
	 .addField('club', 'selectObject', {
                validators: {
                    required: true
                },
                options: {
                    defaultOption: '',
                    class: 'form__item form__item_select width-350',
                    ngChange: 'field.ngChange(model)'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                fieldData: {
                    ngChange: function (item) {
			console.log(vm.nextyear,vm.validationExpired);
			   vm.form.club = item;
                                if (
                                    item &&
                                    item.fee &&
				    vm.prev_club_id != item.id
 
                                ) {
                                    vm.form.local_fee = +item.fee;
                                } else {
				if (vm.validationExpired) {
                		             vm.form.local_fee = +item.fee;
                        		}
				else if ((new Date().getMonth()=='10' ||new Date().getMonth()=='11') && !vm.nextyear){
			
					  vm.form.local_fee = +item.fee;
                	  	  }
				else

                                    vm.form.local_fee = 0;
                                }
                                vm.form.total_price =
                                    vm.form.price + vm.form.local_fee;                      
                    }
                }
            }, vm.organizations)

                      

                // .addField('club_checkbox', 'checkbox', {
                //     validators: {
                //         required: false
                //     },
                //     options: {
                //         ngChecked: function () {
                //             if ( vm.club_checkbox ) {
                //                 vm.form.club = null;
                //                 vm.club_required = false;
                //             } else {
                //                 vm.club_required = true;
                //             }

                //             return vm.club_checkbox;
                //         }
                //     },
                //     label: 'Я не состою ни в одной организации'
                // })
                .addField(
                    "club_other",
                    "radioCollection",
                    {
                        radio: {
                            label: "name",
                        },
                    },
                    vm.club_other_items
                )
                .addField("phone", "text", {
                    validators: {
                        required: true,
                    },
                    options: {
                        placeholder: "Телефон",
                    },
                })
                .addField("email", "text", {
                    validators: {
                        required: true,
                    },
                    options: {
                        placeholder: "E-mail",
                    },
                })
                .addField("last_name", "text", {
                    validators: {
                        required: true,
                    },
                    options: {
                        placeholder: "Фамилия",
                    },
                })
                .addField("first_name", "text", {
                    validators: {
                        required: true,
                    },
                    options: {
                        placeholder: "Имя",
                    },
                })
                .addField("middle_name", "text", {
                    validators: {
                        required: false,
                    },
                    options: {
                        placeholder: "Отчество",
                    },
                })
                .addField("counter", "text", {
                    validators: {
                        required: true,
                        numericOnly: "",
                    },
                    options: {
                        placeholder: "1",
                        class: "form-counter__input",
                        maxlength: 2,
                    },
                })
                .addField(
                    "country",
                    "uiSelect",
                    {
                        validators: {
                            required: true,
                        },
                        options: {
                            onSelect:
                                "field.uiSelectOptions.onSelect($item, $model)",
                            class: "form__ui-select width-350",
                        },
                        uiSelectOptions: {
                            matchTitle: "{{ $select.selected.name }} ",
                            choicesTitle: "{{ item.name }}",
                            match: {
                                placeholder: "Страна",
                                allowClear: true,
                            },
                            choices: {
                                repeat: "item in field.items track by item.id",
                                refresh:
                                    'field.uiSelectOptions.refreshAutoComplete($select.search, "Country", "country")',
                                refreshDelay: 0,
                            },
                            refreshAutoComplete:
                                autocomplete.refreshAutoComplete,
                            onSelect: function (item) {
                                if (item) {
                                    vm.autoCompleteSelect.country = item.id;
                                    vm.autoCompleteSelect.region = null;
                                    vm.autoCompleteSelect.city = null;

                                    vm.form.country = item;

                                    vm.fields.$fields.region.items = [];
                                    vm.fields.$fields.city.items = [];
                                }
                            },
                        },
                        fieldData: {
                            name: "country",
                        },
                    },
                    autocomplete.get("country")
                )
                .addField("region", "uiTypeahead", {
                    validators: {
                        required: false,
                    },
                    label: null,
                    options: {
                        class: "form__item",
                        placeholder: "Регион",
                        tabindex: 10,
                        uibTypeahead:
                            "row as row.name for row in field.refreshAutoComplete($viewValue, 'KladrRegion')",
                    },
                    fieldData: {
                        clearBtn: true,
                        refreshAutoComplete: function (name, term) {
                            return autocomplete.refreshAutoComplete(
                                name,
                                term,
                                null,
                                vm.autoCompleteSelect
                            );
                        },
                    },
                })
                .addField("city", "uiTypeahead", {
                    validators: {
                        required: false,
                    },
                    label: null,
                    options: {
                        class: "form__item",
                        placeholder: "Населенный пункт",
                        uibTypeahead:
                            "row as row.name for row in field.refreshAutoComplete($viewValue, 'KladrCity')",
                    },
                    fieldData: {
                        clearBtn: true,
                        refreshAutoComplete: function (name, term) {
                            if (angular.isObject(vm.form.region)) {
                                vm.autoCompleteSelect.region =
                                    vm.form.region.id;
                            } else {
                                vm.autoCompleteSelect.region = null;
                            }

                            return autocomplete.refreshAutoComplete(
                                name,
                                term,
                                null,
                                vm.autoCompleteSelect
                            );
                        },
                    },
                })
                .addField("post_index", "text", {
                    validators: {
                        required: false,
                        numericOnly: "",
                    },
                    options: {
                        placeholder: "Индекс",
                    },
                })
                .addField("address", "text", {
                    validators: {
                        required: false,
                    },
                    options: {
                        placeholder: "Улица",
                    },
                })
                .addField("house", "text", {
                    validators: {
                        required: false,
                    },
                    options: {
                        placeholder: "Дом",
                        class: "form__item width-80 margin_r_20",
                    },
                })
                .addField("building", "text", {
                    validators: {
                        required: false,
                    },
                    options: {
                        placeholder: "Кор.",
                        class: "form__item width-80 margin_r_20",
                    },
                })
                .addField("apartment", "text", {
                    validators: {
                        required: false,
                    },
                    options: {
                        placeholder: "Кв.",
                        class: "form__item width-80",
                    },
                });

            function submit() {
                vm.submitted = true;
                vm.show_error = true;

                if (!$scope.membershipForm.$valid) {
                    vm.submitted = false;

                    return false;
                }

                if (!vm.club_checkbox) {
                    vm.form.club_other = undefined;
                }
                 vm.form.achievements = vm.form.achievements.map(function (
                     achievement
                 ) {
                     return {
                        user: vm.form.id,
                         type: achievement.type.id,
                         value: achievement.value,
                         year: achievement.year,
                     };
                 });
                 vm.form.club_next = vm.form.club ? vm.form.club.id : null;

                // не меняем клуб до оплаты

		if (
                   vm.form.total_price > 0 &&
                    vm.form.club.id !== vm.prev_club_id
                ) {
			
                   vm.form.club_next = vm.form.club ? vm.form.club.id : null;
                    if (vm.prev_club_id) {
			console.log(vm.prev_club_id);
                        vm.form.club = vm.prev_club_id;
                    } else {
                        vm.form.club = null;
                    }
                }

                vm.form.save().then(
                    function () {
			console.log(vm.form.total_price);
                        if (vm.form.total_price == 0) {
                            return;
                        }
			console.log(vm.form.id,vm.form.counter,vm.form.club_next);
                        $http
                            .post(Routing.generate("api_post_order"), {
                                user: vm.form.id,
                                club_next: vm.form.club_next,
                            })
                            .then(
                                function (response) {
				console.log(response.data.url);
                                    $window.location.href = response.data.url;
                                },
                                function errorCallback(response) {
                                    response =
                                        http.authenticationListener(response);

                                    $log.error(response);
                                }
                            );
                    },
                    function errorCallback(response) {
                        response = http.authenticationListener(response);

                        vm.submitted = false;

                        $log.error(response);
                    }
                );
            }

            function constructor(
                user,
                price,
                max,
                validationExpired,
                federationFee,
                userClubId,
		nextyear
            ) {
                vm.form = User.get(user, function () {
                    vm.form.counter = 1;

                    vm.form.confirmation = true;
                    vm.max = max;
			vm.nextyear=nextyear;

                    vm.club_checkbox = false;
                    vm.validationExpired = !!validationExpired;

                    if (validationExpired) {
                        vm.form.price = +price;		

                    }else if ((new Date().getMonth()=='10' || new Date().getMonth()=='11') && !nextyear){
			 vm.form.price = +price;
                	    }

			 else {
                        vm.form.price = 0;
                    }

                    if (federationFee) {
                        if (validationExpired) {
                            vm.form.local_fee = federationFee;
                        }
			else if ((new Date().getMonth()=='10' ||new Date().getMonth()=='11') && !nextyear){
			
			 vm.form.local_fee = federationFee;
                	    }

			else {
                            vm.form.local_fee = 0;
                        }
                    } else {
                        vm.form.local_fee = 0;
                    }

                    vm.form.total_price = vm.form.price + vm.form.local_fee;

                    vm.prev_club_id = userClubId;

                    // if ( vm.form.club_other ) {
                    //     vm.club_checkbox = true;
                    // } else {
                    //     vm.form.club_other = vm.club_other_items[0].id;
                    // }

                    vm.progress = false;
                });
            }

            function counter(type) {
                // if (type == 1) {
                //     if (vm.form.counter < vm.max) {
                //         vm.form.counter++;
                //     }
                // } else {
                //     if (vm.form.counter > 1) {
                //         vm.form.counter--;
                //     }
                // }
                return 1;
            }

            function getCounter() {
               // return (
                 //   vm.form.counter +
                //    " " +
                 //   formsUtils.numEnding(vm.form.counter, [
                   //     "год",
                    //    "года",
                    //    "лет",
                   // ])
                //);
	    return "01.01."+new Date().getFullYear()+"-31.12.2022";
            }

            return vm;
        }
    );
